document.querySelectorAll('.awards-rotation__carousel').forEach((carousel) => {
    const logos = Array.from(carousel.querySelectorAll('.awards-rotation__logo'));
    const prevBtn = carousel.querySelector('.awards-rotation__nav--prev');
    const nextBtn = carousel.querySelector('.awards-rotation__nav--next');

    if (logos.length < 2) return;

    let currentIndex = 0;

    function prevIndex(i) {
        return (i - 1 + logos.length) % logos.length;
    }

    function nextIndex(i) {
        return (i + 1) % logos.length;
    }

    function update() {
        logos.forEach((logo) => {
            logo.classList.remove('is-prev', 'is-current', 'is-next');
        });

        logos[prevIndex(currentIndex)].classList.add('is-prev');
        logos[currentIndex].classList.add('is-current');
        logos[nextIndex(currentIndex)].classList.add('is-next');
    }

    function goNext() {
        currentIndex = nextIndex(currentIndex);
        update();
    }

    function goPrev() {
        currentIndex = prevIndex(currentIndex);
        update();
    }

    nextBtn.addEventListener('click', () => goNext());
    prevBtn.addEventListener('click', () => goPrev());

    logos.forEach((logo) => {
        logo.addEventListener('click', () => {
            if (logo.classList.contains('is-prev')) {
                goPrev();
            } else if (logo.classList.contains('is-next')) {
                goNext();
            }
        });
    });

    update();
});
